import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// HOCs
import { compose } from 'redux';
import withLoading from 'hocs/WithLoading';
// Core components
import TableCell from 'components/core/table/TableCell';
import TableRow from 'components/core/table/TableRow';
// Permissions
import OnlyWith from 'components/permissions/OnlyWith';
import permissions from 'constants/Permissions';
// Models
import { desc as deviceModelDesc } from 'models/deviceModel';
// Custom
import { listRowSpecsShape, deviceSlaveDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'deviceSlaves/navigation';
// Components
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import { ShortcutIconButton, EditIconButton, DeleteIconButton } from 'components/buttons/IconButtons';
import DeviceWidget from 'devices/assets/main/DeviceWidget';
import DeviceBatchIdLink from 'production/assets/deviceBatch/DeviceBatchIdLink';
import CompanyIdLink from 'companies/assets/main/CompanyIdLink';

const DeviceSlaveRow = React.forwardRef(({
  deviceSlave, rowSpecs, withLink, handleStartLoading,
  onDelete,
}, ref) => {
  const { id: deviceSlaveId } = deviceSlave;

  // Handlers
  const handleDelete = () => {
    onDelete(deviceSlave);
  };

  return (
    <TableRow
      ref={ref}
      element={deviceSlave}
      rowSpecs={rowSpecs}
      actions={
        withLink
          ? [<ShortcutIconButton key="bLink" primary path={showPath(deviceSlaveId)} />]
          : [
            <EditIconButton key="bEdit" onClick={handleStartLoading} path={showPath(deviceSlaveId)} />,
            <OnlyWith
              key="bDelete"
              permissions={{
                needed: permissions.pDevice.write,
                permissionsOrContext: 'devicePermissions',
              }}
            >
              <DeleteIconButton onClick={handleDelete} />
            </OnlyWith>,
          ]
      }
    >
      <TableCell className={classnames({ 'table-first-details': rowSpecs.withDetails })}>
        <TruncatedTooltipText>{deviceSlave.serial}</TruncatedTooltipText>
      </TableCell>
      <TableCell className="hidden-xs-down">
        <TruncatedTooltipText>{deviceModelDesc(deviceSlave.device_model)}</TruncatedTooltipText>
      </TableCell>
      <TableCell className="table-content-2 hidden-xs-down" noPadding>
        {deviceSlave.device && (
          <DeviceWidget
            device={deviceSlave.device}
            parentId={deviceSlaveId}
            source="deviceSlave"
            tooltipPermission={{
              needed: permissions.pDevice.read,
              permissionsOrContext: 'devicePermissions',
            }}
            withInstallation
          />
        )}
      </TableCell>
      <OnlyWith
        permissions={{
          needed: permissions.pAdmin,
        }}
      >
        <TableCell className="hidden-sm-down">
          <em>TODO</em>
        </TableCell>
      </OnlyWith>
      <OnlyWith
        permissions={{
          needed: permissions.pAdmin,
        }}
      >
        <TableCell className="hidden-lg-down">
          {deviceSlave.device_production_batch_id && (
            <DeviceBatchIdLink deviceBatchId={deviceSlave.device_production_batch_id} />
          )}
        </TableCell>
      </OnlyWith>
      <OnlyWith
        permissions={{
          needed: permissions.pAdmin,
        }}
      >
        <TableCell className="hidden-lg-down">
          <CompanyIdLink companyId={deviceSlave.company_id} />
        </TableCell>
      </OnlyWith>
    </TableRow>
  );
});

DeviceSlaveRow.displayName = 'DeviceSlaveRow';

DeviceSlaveRow.propTypes = {
  deviceSlave: deviceSlaveDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  withLink: PropTypes.bool,
  onDelete: PropTypes.func,
  // From `withLoading` HOC
  handleStartLoading: PropTypes.func.isRequired,
};

DeviceSlaveRow.defaultProps = {
  withLink: false,
  onDelete: null,
};

module.exports = compose(
  withLoading,
)(DeviceSlaveRow);



// WEBPACK FOOTER //
// ./routes/app/routes/deviceSlaves/assets/main/DeviceSlaveRow.js